import styled from "styled-components";
import "../../../../styles/variables.css";

export const WalletConnectionContainer = styled.div`
  text-align: center;
`;

export const DisclaimerText = styled.span<{ slim?: boolean }>`
  text-align: left;
  font-size: var(--fs14);
  margin-left: 15px;
  ${({ slim }) => slim && `font-weight: 400`};
  @media (max-width: 600px) {
    font-size: var(--fs15);
  }
`;

export const WalletList = styled.div``;
